var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 4.85C11.5 7.3 10.128 9.4 8 9.4S4.5 7.3 4.5 4.85C4.5 2.4 5.2 1 8 1s3.5 1.4 3.5 3.85Z",
  stroke: "currentColor",
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m10.1 8.7 4.9 2.8v1.4c0 1.162-.7 2.1-1.4 2.1H2.4c-.7 0-1.4-.938-1.4-2.1v-1.4l4.9-2.8",
  stroke: "currentColor",
  strokeMiterlimit: 10
})));

export default SvgIconPeople;